var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9272_19495)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4141 18.148C17.6311 17.933 17.8511 17.721 18.0731 17.506L18.1531 17.431C18.2531 17.331 18.3381 17.253 18.4021 17.19C18.4351 17.157 18.4651 17.127 18.4831 17.107L18.4921 17.101L18.5381 17.055L18.7731 16.825C24.4931 11.179 31.9941 7.79902 36.7341 7.02502C37.9618 7.48529 39.0778 8.20106 40.0081 9.125L40.0421 9.16302L40.0791 9.20203C41.398 10.554 42.6131 12.0034 43.7141 13.538C43.7571 13.627 43.7811 13.677 43.7921 13.707V13.724C43.7674 13.7781 43.7316 13.8265 43.6871 13.866C43.6462 13.9061 43.6024 13.9432 43.5561 13.977L36.4111 18.957L36.2901 19.034L36.1781 19.122C36.0231 19.236 34.6881 20.388 34.1781 20.108L31.6611 17.735L30.6011 16.613L28.7861 18.075C27.5411 19.075 25.7731 20.554 24.4181 21.893C24.2381 22.07 24.0701 22.241 23.9001 22.42L23.8841 22.433L23.8331 22.478C23.5401 22.741 23.2271 23.041 22.8981 23.366C21.6391 24.611 21.1031 25.088 20.0081 26.06L17.0271 29.05L20.3691 33.463L20.3991 33.522C20.6371 33.984 19.4991 35.28 19.3891 35.417L19.2991 35.525L19.2211 35.643L14.1211 41.572C14.0821 41.6216 14.0401 41.6687 13.9951 41.713C13.9383 41.7776 13.867 41.828 13.7871 41.86H13.7711C12.4151 41.1467 11.1876 40.2122 10.1391 39.095L10.1001 39.061L10.0631 39.027C9.08598 37.7199 8.22725 36.3285 7.49712 34.869C7.32665 34.5418 7.1731 34.206 7.03711 33.863C7.84311 29.455 11.9931 23.506 17.4141 18.148Z",
    stroke: "#003366",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6049 26.719C32.5312 28.8768 30.7837 30.6262 28.627 31.702",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.758 27.8049C37.5081 32.2304 33.8775 35.8023 29.416 37.9799",
    stroke: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.527 27.718C44.1287 31.3512 41.9667 34.6418 39.1873 37.3676C36.4079 40.0933 33.0757 42.1907 29.416 43.518",
    stroke: "#003366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9272_19495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.30d165f64f83a9c74d13f4c4ae8de96b.svg";
export { ForwardRef as ReactComponent };